/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/17/20
 *
 */
import {Type} from "@qwoach/class-transformer-wrapper"
import BaseObject from "@shared/BaseObject";
import UserSubscription from "@shared/Subscription/UserSubscription";



export default class UISubscription extends BaseObject {


	@Type(() => UserSubscription)
	main: UserSubscription[] = []

	@Type(() => UserSubscription)
	genogram: UserSubscription[] = []

	@Type(() => UserSubscription)
	theralogik: UserSubscription[] = []


	constructor() {
		super();
	}

}
